module.exports = require("core-js-pure/stable/instance/sort");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/sort.js
// module id = 599
// module chunks = 0